<template>
  <v-app>
    <v-app-bar app color="blue lighten-4" dark>
      <div class="d-flex align-center">
        <v-img
          alt="Vuetify Logo"
          class="shrink mr-2"
          contain
          src="./assets/CmuhchLogo.png"
          transition="scale-transition"
          max-width="400"
        />

        <v-img
          alt="Vuetify Name"
          class="shrink mt-1 hidden-sm-and-down"
          containn
          min-width="100"
          width="100"
        />
      </div>
      <template v-slot:extension>
        <v-tabs dark show-arrows class="tabs">
          <v-tabs-slider color="grey darken-3"></v-tabs-slider>

          <v-tab to="/"> <span>字母A-Z</span> </v-tab>
          <v-tab to="/inspectCategoryCode"> <span>檢體類別代號</span> </v-tab>
          <v-tab v-for="(item, key) in AZ" :key="key" :to="'/letter/' + item"
            ><span>字母{{ item }}</span></v-tab
          >
        </v-tabs>
      </template>
        <div class="header text-center font-weight-bold">&emsp;&emsp;&emsp;檢驗項目查詢系統</div>
    </v-app-bar>

    <v-main>
      <router-view />
      <div class="footer">
        <p>Copyright © 2022 中國醫藥大學新竹附設醫院</p>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import "@/assets/style.scss";
export default {
  name: "App",

  data: () => ({
    AZ: [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J",
      "K",
      "L",
      "M",
      "N",
      "O",
      "P",
      "Q",
      "R",
      "S",
      "T",
      "U",
      "V",
      "W",
      "X",
      "Y",
      "Z",
    ],
    //
  }),
};
</script>
